module.exports = __webpack_public_path__ + "static/media/select-services.0270a04c.svg";